import React from "react";
import "./insMasterDetailChart.scss";
import { InsChartFactory } from "components/widgets";
import { useWidgetChildrenId } from "components/widgets/hooks/use-current-widget";
export const InsMasterDetailChart = (props) => {
    const childrenId = useWidgetChildrenId(props.sectionId, props.widgetId);
    const propsChildren = { index: -1, isMaximizedOne: props.isMaximizedOne, sectionId: props.sectionId, widgetId: childrenId || "" };
    return React.createElement("div", { className: "ins-master-detail-content" },
        React.createElement("div", { className: "left" },
            React.createElement(InsChartFactory, { ...props })),
        React.createElement("div", { className: "right" },
            React.createElement(InsChartFactory, { ...propsChildren })));
};
